import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance2xdbr0bdtxbh1 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.a5y_1 = call;
        this.b5y_1 = responseData.z5j_1;
        this.c5y_1 = responseData.u5j_1;
        this.d5y_1 = responseData.x5j_1;
        this.e5y_1 = responseData.v5j_1;
        this.f5y_1 = responseData.a5k_1;
        var tmp = this;
        var tmp_0 = responseData.y5j_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.g5y_1 = tmp0_elvis_lhs == null ? Companion_getInstance().f4k_1 : tmp0_elvis_lhs;
        this.h5y_1 = responseData.w5j_1;
      }
      r5i() {
        return this.a5y_1;
      }
      ew() {
        return this.b5y_1;
      }
      a5j() {
        return this.c5y_1;
      }
      b5j() {
        return this.d5y_1;
      }
      c5j() {
        return this.e5y_1;
      }
      d5j() {
        return this.f5y_1;
      }
      z5i() {
        return this.g5y_1;
      }
      l50() {
        return this.h5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
